export default "__VITE_ASSET__edf470f5__"